module.exports = "/_next/static/images/gt-bc5b62b6825c78f6a907cb2d6e3ace1a.svg";